import Dialog from '@mui/material/Dialog';
import { Box, Button, Typography, useTheme, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { FormButton } from 'theme/elements/Buttons';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

type props = {
	open: boolean;
	handleContinue: any;
	handleCancel: any;
	title?: string;
	subTitle?: string;
	continueLabel?: string;
	cancelLabel?: string;
	popupIcon?: any;
};

export default function CancelDialog(props: props) {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	return (
		<Dialog
			open={props.open}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			sx={{ '& .MuiPaper-root': { margin: '8px' } }}
		>
			<Box sx={{ textAlign: 'center', padding: '12px 12px 36px 12px' }}>
				<Stack spacing={4}>
					<Box sx={{ height: '40px' }}>
						<Box
							sx={{
								background: theme.palette.root.darkGrayed_028,
								width: '40px',
								height: '40px',
								textAlign: 'center',
								float: 'right',
								borderRadius: '8px',
								cursor: 'pointer',
							}}
						>
							<CloseIcon
								onClick={props.handleContinue}
								sx={{ width: '20px', height: '40px', margin: 'auto' }}
							/>
						</Box>
					</Box>
					<Box
						sx={{
							width: '56px',
							margin: 'auto!important',
							height: '56px',
							backgroundColor: 'red',
							borderRadius: '100%',
							textAlign: 'center',
							boxShadow: '0px 2px 8px 0px #FF000052',
						}}
					>
						{props?.popupIcon || <PriorityHighIcon sx={{ color: '#fff', height: '56px', width: '20px' }} />}
					</Box>
					<Stack
						spacing={0}
						sx={{
							padding: '0 35px',
							[theme.breakpoints.down('sm')]: { padding: '0 0' },
							direction: 'ltr',
						}}
					>
						<Typography
							variant="h3"
							sx={{
								padding: '0 60px',
								[theme.breakpoints.down('sm')]: { padding: '0 20px' },
							}}
						>
							{props?.title || t('message.cancel_process.title')}
						</Typography>
						<Typography variant="body3">
							{props?.subTitle || t('message.cancel_process.subtitle')}
						</Typography>
					</Stack>
					<Stack
						gap={{ sm: 2, xs: 1 }}
						direction={{ sm: 'row', xs: 'row' }}
						justifyContent={{ xs: 'space-evenly', sm: 'center' }}
					>
						<FormButton>
							<Button variant="outlined" onClick={props.handleContinue}>
								{props?.continueLabel || `${t('portal.actions.no')}, ${t('portal.actions.continue')}`}
							</Button>
						</FormButton>
						<FormButton>
							<Button variant="outlined" onClick={props.handleCancel} autoFocus>
								{props?.cancelLabel || `${t('portal.actions.yes')}, ${t('portal.actions.cancel')}`}
							</Button>
						</FormButton>
					</Stack>
				</Stack>
			</Box>
		</Dialog>
	);
}
